import { BehaviorSubject } from 'rxjs';

import { fetchWrapper } from '@/helpers/fetch-wrapper';

const userSubject = new BehaviorSubject(typeof window !== 'undefined' && JSON.parse(localStorage.getItem('user')));

export const userService = {
    user: userSubject.asObservable(),
    get userValue() { return userSubject.value },
    login,
    logout,
    register,
    forgotPassword,
    resetPassword,
    resetPasswordWithCode,
};

async function login(email, password) {
    const user = await fetchWrapper.post('/api/users/authenticate', { email, password });

    userSubject.next(user);
    localStorage.setItem('user', JSON.stringify(user));
}

function logout() {
    localStorage.removeItem('user');
    userSubject.next(null);
    window.location.href = "/"; 
}

async function register(user) {
    await fetchWrapper.post(`/api/users/register`, user);
}

async function forgotPassword(email, { viaCode } = {}) {
    await fetchWrapper.post('/api/users/forgot-password', { email, viaCode });
}

async function resetPassword({ token, newPassword, passwordConfirm }) {
    const user = await fetchWrapper.post('/api/users/reset-password', { token, newPassword, passwordConfirm });

    userSubject.next(user);
    localStorage.setItem('user', JSON.stringify(user));
}

async function resetPasswordWithCode({ email, code, newPassword, passwordConfirm }) {
    const user = await fetchWrapper.post('/api/users/reset-password-code', { email, code, newPassword, passwordConfirm });

    userSubject.next(user);
    localStorage.setItem('user', JSON.stringify(user));
}

async function isLogged() {
     return (!userService.userValue) ? (false):(true); 
}




